import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatSaleTypeModel } from 'src/app/model/cat-sale-type.model';

@Injectable({
  providedIn: 'root'
})
export class CatSaleTypeService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  // catalogo completo (activos e inactivos)
  getAll=()=> {
    return this.http.get(`${this.url}/CatSaleType/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  // catalogo solo activos (id/description) para selectores
  catalog=()=> {
    return this.http.get(`${this.url}/CatSaleType/Catalog`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getOne=(saleTypeId:number)=> {
    return this.http.get(`${this.url}/CatSaleType/${saleTypeId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  // crear (sin saleTypeId) o editar/reactivar (con saleTypeId)
  save=(saleType:CatSaleTypeModel)=> {
    return this.http.post(`${this.url}/CatSaleType/SaveUpdate`, saleType)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  // baja logica
  delete=(saleTypeId:number, userId:number)=> {
    return this.http.delete(`${this.url}/CatSaleType/${saleTypeId}?userId=${userId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
